var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"timetablePage"},[_c('page-banner',{attrs:{"title":"Schedule"}}),_vm._v(" "),_c('div',{staticClass:"container"},[(_vm.days.length > 0)?_c('schedule-table',{attrs:{"days":_vm.days}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }